import { f as e } from "./createTheme-02ce03eb.js";
const t = {
  common: {
    white: "#FFFFFF",
    secondary: "#FF8C22",
    pending: "#FFD600",
    gradientBlue: "linear-gradient(270deg, #00B596 0%, #0A78CD 100%);",
    gradientLightBlue: "linear-gradient(270deg, #00CBA9 0%, #0099FF 100%);",
    gradientRisk: "linear-gradient(90deg, #00B596 0%, #ECBE4C 36.46%, #ECBE4C 59.9%, #D14343 100%);",
    gradientRiskReverse: "linear-gradient(90deg, #00B596 6.25%, #ECBE4C 34.9%, #D14343 76.56%);",
    gradientRisk2: "linear-gradient(270deg, #00B596 9.25%, #ECBE4C 12.9%, #D14343 65.56%);"
  },
  darkBlue: {
    c100: "#25245F",
    c90: "#3B3A6F",
    c70: "#66668F",
    c50: "#9292AF",
    c30: "#BDBDCE",
    c20: "#D3D3DF",
    c10: "#E9E9EF",
    c5: "#F4F4F7"
  },
  blue: {
    c100: "#0A78CD",
    c20: "#CEE4F5",
    c5: "#F2F8FC"
  },
  lightBlue: {
    c100: "#0099FF",
    c40: "#99D6FF",
    c30: "#B3E0FF",
    c20: "#CCEBFF",
    c10: "#E5F5FF"
  },
  acqua: {
    c120: "#00B596",
    c110: "#00CBA9",
    c100: "#00E2BC"
  },
  positive: {
    c130: "#398468",
    c100: "#52BD94",
    c5: "#F6FCFA"
  },
  negative: {
    c120: "#A73636",
    c100: "#D14343",
    c5: "#FDF6F6"
  }
}, i = {
  fontFamily: "Poppins",
  h1: {
    fontSize: "96px",
    lineHeight: "110px",
    fontWeight: "600"
  },
  h2: {
    fontSize: "60px",
    lineHeight: "80px",
    fontWeight: "600"
  },
  h3: {
    fontSize: "48px",
    lineHeight: "70px",
    fontWeight: "600"
  },
  h4: {
    fontSize: "32px",
    lineHeight: "40px",
    fontWeight: "600"
  },
  h5: {
    fontSize: "24px",
    lineHeight: "36px",
    fontWeight: "600"
  },
  h6: {
    fontSize: "20px",
    lineHeight: "32px",
    fontWeight: "600"
  },
  quote1: {
    fontSize: "24px",
    lineHeight: "40px",
    fontWeight: "500"
  },
  quote2: {
    fontSize: "20px",
    lineHeight: "32px",
    fontWeight: "400"
  },
  body1: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400
  },
  body2: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400
  },
  body1M: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 500
  },
  body2M: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 500
  },
  body1B: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600
  },
  body2B: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 600
  },
  button1: {
    fontSize: "15px",
    lineHeight: "20px",
    fontWeight: 700
  },
  button2: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 700
  },
  button3: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 700
  },
  caption1: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 400
  },
  caption2: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600
  },
  overline1: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    letterSpacing: "1px"
  },
  overline2: {
    fontSize: "10px",
    lineHeight: "14px",
    fontWeight: "600",
    letterSpacing: "1px"
  },
  overline3: {
    fontSize: "14px",
    lineHeight: "16px",
    letterSpacing: "1px"
  }
}, n = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88, 92, 96, 100], g = e({ spacing: n, palette: t, typography: i });
export {
  g as t
};
